import React from "react";
import { useOutletContext } from "react-router-dom";
import { HUB_ILLUSTRATIONS } from "../../constants/mediaAssets.js";
import HubIllustration from "../HubIllustration.js";
import WellnessScaleBlock from "../WellnessScaleBlock.js";
import MentalPatternsBackLink from "./MentalPatternsBackLink.js";
import LockedPatternTease from "./LockedPatternTease.js";
import { useMentalPatterns } from "./MentalPatternsContext.js";
import { MENTAL_LOAD_INDEX_TITLE } from "../../constants/wellness.js";
import { MIN_INSIGHTS_FOR_PATTERNS } from "../../constants/mentalPatternsHub.js";

const MentalPatternsMentalLoad = () => {
  const { isSubscriber, verifiedEmail } = useOutletContext() || {};
  const { wellness, totalReflections, lockedPatternTease } = useMentalPatterns();
  const { score, label, helper, reasons } = wellness;
  const showLockedTease =
    !isSubscriber && totalReflections >= MIN_INSIGHTS_FOR_PATTERNS && score != null;

  return (
    <>
      <MentalPatternsBackLink />
      <div className="mental-patterns__hero">
        <HubIllustration src={HUB_ILLUSTRATIONS.wellness} alt="" className="hub-illustration hub-illustration--wellness" />
        <h1>{MENTAL_LOAD_INDEX_TITLE}</h1>
      </div>
      {score == null ? (
        <p>No reflections yet. Add thought records to see your mental load index.</p>
      ) : showLockedTease ? (
        <LockedPatternTease tease={lockedPatternTease} verifiedEmail={verifiedEmail} />
      ) : (
        <section className="wellness-patterns" aria-label={MENTAL_LOAD_INDEX_TITLE}>
          <p className="wellness-patterns__intro">
            Pattern intensity from your reflection history — emotion tags, stress load, anger patterns,
            and response follow-through.
          </p>
          <WellnessScaleBlock score={score} label={label} helper={helper} reasons={reasons} />
          {totalReflections > 0 ? (
            <p className="mental-patterns__section-note">
              Based on {totalReflections} reflection{totalReflections !== 1 ? "s" : ""} in your history.
            </p>
          ) : null}
        </section>
      )}
    </>
  );
};

export default MentalPatternsMentalLoad;
